import { Component, OnInit } from '@angular/core'
import { GlobalService } from '../../../services/global.service'
import { MerchantService } from '../../../services/merchant.service'
import { ActivatedRoute, Router } from '@angular/router'
import { Merchant, merchantParkingsPath, merchantsPath, Parking, parkingsPath, ParkingStatus } from '@parkupp/core'
import { collection, collectionData, doc, docData, getDocs, limit, query, where } from '@angular/fire/firestore'
import * as firestore from 'firebase/firestore'

@Component({
    selector: 'app-whitelabel',
    templateUrl: './whitelabel.component.html',
    styleUrls: ['./whitelabel.component.scss'],
})
export class WhitelabelComponent implements OnInit {
    merchant: Merchant
    parkings: Parking[]
    wrapperClass = 'container'

    constructor(public globalService: GlobalService, private merchantService: MerchantService, private router: Router, private activatedRoute: ActivatedRoute) {}

    async ngOnInit(): Promise<void> {
        let ref: any = null

        if (this.globalService.subdomain == 'cityprop') {
            ref = query(collection(this.merchantService.firestore, parkingsPath()), where('buildingName', '==', this.globalService.whitelabelBuilding))
        } else if (this.globalService.subdomain == 'advance') {
            ref = query(collection(this.merchantService.firestore, parkingsPath()), where('managerName', '==', this.globalService.whitelabelManager))
        } else if (this.globalService.subdomain == 'admyt') {
            ref = query(collection(this.merchantService.firestore, parkingsPath()), where('admytQr', '==', true))
        } else if (this.globalService.whitelabelName) {
            ref = query(collection(this.merchantService.firestore, parkingsPath()), where('whiteLabelName', '==', this.globalService.whitelabelName))
        }
        // else if (this.globalService.whitelabelName !== '') {
        //     ref = query(collection(this.merchantService.firestore, parkingsPath()), where('whiteLabelName', '==', this.globalService.whitelabelName))
        // }
        else {
            // // (this.globalService.subdomain == 'spire')
            const merchantQuerySnapshot = await getDocs(query(collection(this.merchantService.firestore, merchantsPath()), where('subdomain', '==', this.globalService.subdomain), limit(1)))
            console.log(merchantQuerySnapshot)

            if (!merchantQuerySnapshot.empty) {
                const merchantDoc = merchantQuerySnapshot.docs[0]
                const merchantData = merchantDoc.data()
                this.merchant = new Merchant(merchantData)
                this.merchant.$key = merchantDoc.id

                let merchantRef = doc(this.merchantService.firestore, merchantsPath(), this.merchant.$key) as any
                ref = query(collection(this.merchantService.firestore, parkingsPath()), where('merchantRef', '==', merchantRef))
            }
        }

        if (ref != null) {
            collectionData(ref!, { idField: 'documentId' }).subscribe((documents: any[]) => {
                const parkings: Parking[] = []
                documents.forEach((documentData) => {
                    let parking: Parking = documentData as any
                    parking.$key = documentData.documentId

                    if (parking.parkingStatus != ParkingStatus.DISABLED && parking.parkingStatus != ParkingStatus.PENDING) {
                        parkings.push(parking)
                    }
                })
                this.parkings = parkings
            })
        }

        if (this.globalService.subdomain == 'redefine') {
            this.wrapperClass = ''
        }
    }

    onSelect(parking: Parking) {
        this.router.navigate([`parking/${parking.$key}`])
    }
}
